module.exports = __webpack_public_path__ + "static/img/reason_head_2.83102846.png";